import { Box } from "@mui/material";
import { CheckoutState, SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { BannerCouponName, UpgradeDialogSource } from "schemas/dashboard";
import { Plans } from "schemas/payments";
import { routes } from "schemas/routes";

import { trackEvent } from "utils/tracking";

interface Props {
  color?: string;
  children: React.ReactNode;
  fromPastDue?: boolean;
}

const BannerWrapper = ({ children, color = "#1d70ff", fromPastDue }: Props) => {
  const navigate = useNavigate();
  const { setUpgradeDialogSource, subscription, setOpenCheckoutDialog } =
    useContext(SubscriptionContext);
  const bannerCouponName = subscription?.bannerPromoCode?.couponName;

  const handleClick = () => {
    if (fromPastDue) {
      trackEvent("Past Due Banner Clicked");
      navigate(`/${routes.settings}`);
      return;
    }

    if (bannerCouponName === BannerCouponName.end_of_year_sale) {
      setUpgradeDialogSource(
        UpgradeDialogSource.end_of_year_sale_countdown_banner,
      );
    } else if (bannerCouponName === BannerCouponName.money_back_guarantee) {
      openMoneyBack();
    } else {
      setUpgradeDialogSource(UpgradeDialogSource.countdown_banner);
    }
  };

  const openMoneyBack = () => {
    const state: CheckoutState = {
      plan: Plans.VA_YEARLY,
      source: "Money Back Guarantee Banner",
      pageSource: window.location.pathname,
    };
    setOpenCheckoutDialog(state);
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        backgroundColor: color,
        py: 0.5,
        px: { xs: 1, md: 2 },
        display: { xs: "auto", md: "flex" },
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        cursor: "pointer",
        "&:hover": {
          opacity: 0.5,
        },
      }}
    >
      {children}
    </Box>
  );
};
export default BannerWrapper;
